var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsotypeMapfreEconomics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg13",
    viewBox: "0 0 396.83 365.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#fcfcfc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2",
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1",
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 237",
    id: "Grupo_237"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.08,263.74l-39,58.9v42.55h226.7V330.32H209.08V263.74",
    className: "cls-1",
    "data-name": "Trazado 361",
    id: "Trazado_361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.12,0V42.52l39,58.9V34.84H396.82V0H170.12",
    className: "cls-1",
    "data-name": "Trazado 362",
    id: "Trazado_362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.12,200.2V165.32H251.39l11.41,17.26-11.66,17.63h118",
    className: "cls-1",
    "data-name": "Trazado 363",
    id: "Trazado_363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.32,1.05H0L120.26,182.77,0,364.49H80.86L201.6,182.77,81.32,1.05",
    className: "cls-1",
    "data-name": "Trazado 364",
    id: "Trazado_364"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotypeMapfreEconomics);
export default __webpack_public_path__ + "static/media/isotype-mapfre-economics.b0945bf173eff0c1450d91fc794bb0bb.svg";
export { ForwardRef as ReactComponent };